import React from 'react'

function UpdateUser() {
  return (
    <div>Update User</div>
  )
}

export default UpdateUser